var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    _vm._g(
      _vm._b(
        {
          attrs: {
            title: "新增风险设备",
            "close-on-click-modal": false,
            top: "120px",
            "append-to-body": "",
          },
        },
        "el-dialog",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [
      _c(
        "el-form",
        {
          ref: "deviceForm",
          attrs: {
            "label-width": "120px",
            model: _vm.riskForm,
            rules: _vm.rules,
          },
        },
        [
          _c("el-form-item", { attrs: { label: "渠道+UID", prop: "appid" } }, [
            _c(
              "div",
              { staticStyle: { "margin-bottom": "10px" } },
              [
                _c("el-input", {
                  staticClass: "inputs",
                  attrs: {
                    placeholder: "请选择渠道（单选）",
                    type: "textarea",
                  },
                  on: {
                    focus: function ($event) {
                      return _vm.handleClickChannel()
                    },
                  },
                  model: {
                    value: _vm.riskForm.appid,
                    callback: function ($$v) {
                      _vm.$set(_vm.riskForm, "appid", $$v)
                    },
                    expression: "riskForm.appid",
                  },
                }),
              ],
              1
            ),
          ]),
          _c(
            "el-form-item",
            { attrs: { label: " ", prop: "uid" } },
            [
              _c("el-input", {
                staticClass: "inputs",
                attrs: { placeholder: "请输入UID", clearable: "" },
                model: {
                  value: _vm.riskForm.uid,
                  callback: function ($$v) {
                    _vm.$set(_vm.riskForm, "uid", $$v)
                  },
                  expression: "riskForm.uid",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "Mac 地址", prop: "mac" } },
            [
              _c("el-input", {
                staticClass: "inputs",
                attrs: { placeholder: "请输入Mac地址", clearable: "" },
                model: {
                  value: _vm.riskForm.mac,
                  callback: function ($$v) {
                    _vm.$set(_vm.riskForm, "mac", $$v)
                  },
                  expression: "riskForm.mac",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "AndroidID", prop: "androidId" } },
            [
              _c("el-input", {
                staticClass: "inputs",
                attrs: { placeholder: "请输入AndroidID", clearable: "" },
                model: {
                  value: _vm.riskForm.androidId,
                  callback: function ($$v) {
                    _vm.$set(_vm.riskForm, "androidId", $$v)
                  },
                  expression: "riskForm.androidId",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "IDFA", prop: "idfa" } },
            [
              _c("el-input", {
                staticClass: "inputs",
                attrs: { placeholder: "请输入IDFA", clearable: "" },
                model: {
                  value: _vm.riskForm.idfa,
                  callback: function ($$v) {
                    _vm.$set(_vm.riskForm, "idfa", $$v)
                  },
                  expression: "riskForm.idfa",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "手机号", prop: "phone" } },
            [
              _c("el-input", {
                staticClass: "inputs",
                attrs: { placeholder: "请输入手机号", clearable: "" },
                model: {
                  value: _vm.riskForm.phone,
                  callback: function ($$v) {
                    _vm.$set(_vm.riskForm, "phone", $$v)
                  },
                  expression: "riskForm.phone",
                },
              }),
            ],
            1
          ),
          _c("el-form-item", { attrs: { label: "风险等级", prop: "level" } }, [
            _c(
              "div",
              { staticClass: "radio-wrapper" },
              [
                _c(
                  "el-radio-group",
                  {
                    model: {
                      value: _vm.riskForm.level,
                      callback: function ($$v) {
                        _vm.$set(_vm.riskForm, "level", $$v)
                      },
                      expression: "riskForm.level",
                    },
                  },
                  _vm._l(_vm.riskLevel, function (item) {
                    return _c(
                      "el-radio",
                      {
                        key: item.label,
                        staticStyle: { display: "block" },
                        attrs: { label: item.level },
                      },
                      [
                        _vm._v(
                          "\n            " + _vm._s(item.key) + "\n            "
                        ),
                        _c("div", { staticClass: "info" }, [
                          _vm._v(_vm._s(item.text)),
                        ]),
                      ]
                    )
                  }),
                  1
                ),
              ],
              1
            ),
          ]),
          _c(
            "el-form-item",
            { attrs: { label: "备注", prop: "remark" } },
            [
              _c("el-input", {
                staticClass: "inputs",
                attrs: {
                  type: "textarea",
                  maxlength: "500",
                  placeholder: "备注内容",
                  clearable: "",
                },
                model: {
                  value: _vm.riskForm.remark,
                  callback: function ($$v) {
                    _vm.$set(_vm.riskForm, "remark", $$v)
                  },
                  expression: "riskForm.remark",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("channel-popups", {
        attrs: {
          visible: _vm.showPopups,
          "app-id": _vm.scopeAppId,
          isRabbittactics: true,
        },
        on: {
          "update:visible": function ($event) {
            _vm.showPopups = $event
          },
          comfirm: _vm.handleConfirm,
        },
      }),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.onSave } },
            [_vm._v("保存")]
          ),
          _c("el-button", { on: { click: _vm.cancel } }, [_vm._v("取消")]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }